export function getLocalValue<T = null>(key: string, defaultValue: T): JSON | T {
    const rawVal = localStorage.getItem(key);
    return rawVal ? JSON.parse(rawVal) : defaultValue;
}

export function setLocalValue<T>(key: string, value: T) {
    if (value !== undefined) {
        localStorage.setItem(key, JSON.stringify(value));
    } else {
        clearlocalValue(key);
    }
}

export function clearlocalValue(key: string) {
    localStorage.removeItem(key);
}

export function clearAllLocalStorage() {
    localStorage.clear();
}
